// extracted by mini-css-extract-plugin
export var hidden = "_rp-0";